export default {
  title: '위치정보사업 이용약관',
  text: [
    {
      title: '제 1장 총칙',
    },
    {
      title: '제 1조 (약관의 적용)',
      desc: '1. 콩테크(주) (이하 “회사”라 합니다.)의 위치정보사업 기본 약관은 “정보통신망 이용 촉진 등에 관한 법률” 상의 개인정보보호 규정 및 정보통신부가 제정한“개인정보보호 지침” 및 “위치정보의 보호 및 이용 등에 관한 법률”을 준수하고 있습니다.<br/><br/>2. 회사는 지정된 홈페이지(https://www.kong-tech.com 및 https://check.kong-tech.com)에 위치정보사업 기본 약관을 게시하는 방법으로 공지합니다.<br/><br/>3. 회사의 위치정보사업 기본 약관은 위치정보사업 또는 위치기반서비스사업의 이용조건 및 절차와 이용에 필요한 기본사항을 규정합니다.'
    },
    {
      title: '제 2조 (용어의 정리)',
      desc: '1. “위치정보”라 함은 이동성이 있는 물건 또는 개인이 특정한 시간에 존재하거나 존재하였던 장소에 관한 정보로서 전기통신기본법 제2조 제2호 및 제3호의 규정에 따른 전기통신설비 및 전기통시회선설비를 이용하여 수집된 것을 말합니다.<br/><br/>2. “개인위치정보”라 함은 특정 개인의 위치정보(위치정보 만으로는 특정 개인의 위치를 알 수 없는 경우에도 다른 정보와 용이하게 결합하여 특정 개인의 위치를 알 수 있는 것을 포함한다)를 말합니다.<br/><br/>3. “개인위치정보주체”라 함은 개인위치정보에 의하여 식별되는 자를 말합니다.<br/><br/>4. “위치정보 수집자료 확인자료”라 함은 위치정보의 수집요청인, 수집일시 및 수집방법에 관한 자료(위치정보를 제외한다)를 말합니다.<br/><br/>5. “위치정보 이용ᐧ제공사실 확인자료”라 함은 위치정보를 제공받는 자, 취득경로, 이용ᐧ제공일시 및 이용ᐧ제공방법에 관한 자료(위치정보를 제외한다)를 말합니다.<br/><br/>6. “위치정보사업”이라 함은 위치정보를 수집하여 위치기반서비스 사업자에게 제공하는 것을 사업으로 영위하는 것을 말합니다.<br/><br/>7. “위치기반서비스사업”이라 함은 위치정보를 이용한 서비스(이하“위치기반서비스”라 한다)를 제공하는 것을 사업으로 영위하는 것을 말합니다.<br/><br/>8. “위치정보시스템”이라 함은 위치정보사업 및 위치기반서비스사업을 위하여 정보통신망이용 촉진 및 정보 보호 등에 관한 법률 제2조 제1항 제1호의 규정에 의한 정보통신망을 통하여 위치정보를 수집ᐧ저장ᐧ분석ᐧ이용 및 제공할 수 있도록 서로 유기적으로 연계된 컴퓨터의 하드웨어, 소프트웨어, 데이터베이스 및 인적자원의 결합체를 말합니다.'
    },
    {
      title: '제 3조 (약관의 개정)',
      desc: '1. 약관의 개정이 필요한 경우, 회사는 정된 약관을 적용하고자 하는 날(이하“효력발생일”)로부터 30일 이전에 약관이 개정된다는 사실과 개정된 내용 등을 아래에 규정된 방법 중 1가지 이상의 방법으로 회원에게 고지하여 드립니다.<br/><br/>① e-mail을 통한 통보<br/>② 서면통보<br/>③ 홈페이지(www.kong-tech.com) 내 게시<br/>④ 일간지 공고<br/><br/>2. 회사가 e-mail 또는 서면으로 이 약관이 개정된 사실 및 개정된 내용을 회원에게 고지하고자 하는 경우에는 회원이 회사에 기제공한 e-mail 주소 또는 주소지 중 가장 최근에 제공된 e-mail 주소 또는 주소지로 통보합니다. 회원이 회사에 제공한 e-mail 주소 또는 주소지를 수정 또는 변경하지 않음으로 인하여 개정된 약관의 내용을 통보 받지 못한 데 대하여 어떠한 책임도 지지 않습니다.<br/><br/>3. 본 조에 따라 개정된 약관(이하“개정약관”)은 원칙적으로 효력발생일로부터 이후 개정 시까지 유효합니다.<br/><br/>4. 이 약관의 개정과 관련하여 이의가 있는 회원은 회원탈퇴를 할 수 있습니다. 단, 이의가 있음에도 불구하고 본 조 제①항 내지 제②항에 따른 회사의 고지가 있은 후 30일 이내에 회원탈퇴를 하지 않은 회원은 개정약관에 동의한 것으로 봅니다.<br/><br/>5. 본 조에서 정한 고지방법 및 고지의 효력은 이 약관의 각 조항에서 규정하는 개별적인 또는 전체적인 통지의 경우에 이를 준용합니다.'
    },
    {
      title: '제 2장 서비스 이용 약관',
    },
    {
      title: '제 4조 (계약의 성립)',
      desc: '1. 위치정보사업 이용계약은 이용고객의 계약과 회사의 승낙으로 이루어집니다.<br/><br/>2. 회사는 업무 수행상 또는 기술상 지장이 없는 경우에 그 서비스 이용을 접수합니다.<br/><br/>3. 회사는 이용계약이 이루어진 경우 다음 사항을 이용자에게 통지합니다.<br/><br/>① 이용자 ID, 비밀번호<br/>② 서비스 제공 개시일<br/>③ 요금에 관한 사항<br/>④ 이용자의 권익보호 및 회사의 의무에 관한 사항.'
    },
    {
      title: '제 5조 (이용신청의 불승낙과 승낙)',
      desc: '1. 회사는 다음에 해당하는 이용신청에 대하여는 승낙을 아니할 수 있습니다.<br/><br/>① 이용자가 신청한 이용자 아이디(ID)가 이미 다른 이용자에 의해 쓰이고 있는 경우<br/>② 서비스의 정상적인 제공을 저해하거나 다른 이용자의 서비스 이용에 지장을 줄 것으로 예상될 경우<br/>③ 이용료 등을 납부하지 아니하여 지속적인 서비스 제공이 불가능한 경우<br/>④ 이용계약이 해지된 자가 체납된 이용료를 납부하지 아니한 경우<br/>⑤ 이용신청 요건이 미비하거나 본인의 확인이 불가능할 경우.'
    },
    {
      title: '제 6조 (이용자 아이디(ID)관리 등)',
      desc: '1. 이용자 아이디(ID) 및 비밀번호에 대한 모든 관리책임은 이용자에게 있습니다.<br/><br/>2. 이용자가 신청 또는 변경하여 사용하는 이용자 아이디(ID) 및 비밀번호에 의하여 발생하는 서비스 이용 상의 과실 또는 제3자에 의한 부정사용 등에 대한 모든 책임은 이용자에게 있습니다. 단, 회사의 고의 또는 중대한 과실이 있는 경우에는 그리하지 아니합니다.'
    },
    {
      title: '제 3장 서비스 개요',
    },
    {
      title: '제 7조 (서비스 개요)',
      desc: '1. 회사는 직접 위치정보를 수집하거나 위치정보사업자로부터 위치정보를 전달받아 아래와 같은 위치정보 사업 또는 위치기반 서비스사업을 제공합니다.<br/><br/>① Beacon을 활용한 RTLS(Real Time Location System) 서비스: 근거리 및 실내와 같은 제한된 공간에서 개인 위치정보주체의 위치정보와 이동동선 정보가 저장됩니다.<br/><br/>② GPS를 활용한 실외에서의 위치확인 및 위치추적: 원거리 및 실외와 같은 광범위한 공간에서 개인위치정보주체의 위치정보와 이동동선 정보가 저장됩니다.<br/><br/>③ 위치정보를 활용한 시간정보 제공: 개인위치정보주체의 실내, 실외 위치정보를 수집하여 이동동선 및 동선별 체류시간 또는 이동시간을 측정하여 제공합니다.<br/><br/>④ 출입통제 시스템: 개인위치 정보주체 또는 이동성 있는 기기의 위치를 이용하여 접근권한이 없는 자의 비정상적인 침입 및 접근 시도 등을 차단합니다.<br/><br/>⑤ 위치정보를 활용한 대상 찾기: 현재 위치를 활용하여 같은 서비스를 이용하고 있는 사용자 또는 이동성 있는 기기의 실시간 위치를 확인할 수 있습니다.<br/><br/>⑥ 위치정보의 공유: 개인위치정보주체 또는 이동성 있는 기기의 위치정보를 안전 등의 목적으로 지인 또는 개인위치정보 주체가 지정한 제3자에게 공유합니다.<br/><br/>2. 회사의 상호 및 주소, 연락처는 다음과 같습니다.<br/><br/>∎ 회 사 명: 콩테크(주)<br/>∎ 대 표 자: 이 학 경<br/>∎ 주 소 지: 경기도 성남시 분당구 대왕판교로 660(삼평동 유스페이스1 비동) 1203호<br/>∎ 대표전화: 1522-1625<br/>∎ 팩시밀리: 070-5143-6695<br/>∎ 이 메 일: pr@orbro.io'
    },
    {
      title: '제 4장 서비스의 이용',
    },
    {
      title: '제 8조 (서비스의 이용시간 및 중지)',
      desc: '1. 서비스의 이용시간은 회사의 업무상 및 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다.<br/><br/>2. 다음과 같이 서비스의 이용을 중지하고자 하는 경우에 회사는 서비스 홈페이지에 그 사유 및 기간을 명시하여 게시하거나 별도로 사전에 공지하여야 합니다.'
    },
    {
      title: '제 5장 이용계약의 중지 및 해지',
    },
    {
      title: '제9조 (개인정보의 열람 및 정정)',
      desc: '1. 이용자는 언제든지 등록되어 있는 이용자의 개인정보를 열람하거나 정정하실 수 있으며, 개인위치정보가 제3자에게 제공된 이유 및 내용에 대하여 열람 또는 고지를 요구할 수 있습니다.<br/><br/>2. 이용자가 개인정보 및 위치정보의 열람 및 정정 요구 시 회사는 즉각적으로 이를 수행할 의무가 있으며, 회사가 정한 서류양식 및 개인위치정보주체란 적절한 증빙을 제출하여야 합니다.'
    },
    {
      title: '제 10조 (개인위치정보 수집, 이용, 제공에 대한 동의철회)',
      desc: '1. 개인정보의 수집, 이용, 제공에 대해 이용자께서 동의하신 내용을 이용자는 언제든지 전부 또는 일부에 다하여 철회할 수 있습니다.<br/><br/>2. 이용자가 개인위치정보의 수집, 이용 및 제공에 대한 전부 또는 일부 철회를 요청할 경우 지체 없이 개인위치정보 및 위치정보 이용ᐧ제공사실 확인자료(동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 이용ᐧ제공사실 확인자료에 한함)를 파기합니다.<br/><br/>3. 이용자가 개인위치정보의 수집, 이용, 제공에 대한 동의철회 시 회사는 즉각적으로 이를 수행할 의무가 있으며, 회사가 정한 서류양식 및 개인위치정보주체란 적절한 증빙을 제출하여야 합니다.'
    },
    {
      title: '제 11조 (개인위치정보 수집, 이용, 제공의 중지)',
      desc: '1. 이용자는 개인위치정보의 수집, 이용 및 제공에 대한 전부 또는 일시적인 중지를 요청할 수 있습니다.<br/><br/>2. 이용자가 개인위치정보의 수집, 이용 및 제공에 대한 전부 또는 일부 중지를 요청할 경우 지체 없이 개인위치정보 및 위치정보 이용ᐧ제공사실 확인자료(동의의 일부를 중지하는 경우에는 중지하는 부분의 개인위치정보 및 위치정보 이용ᐧ제공사실 확인자료에 한함)를 파기합니다.<br/><br/>3. 이용자가 개인위치정보의 수집, 이용, 제공에 대한 동의중지 시 회사는 즉각적으로 이를 수행할 의무가 있으며, 회사가 정한 서류양식 및 개인위치정보주체란 적절한 증빙을 제출하여야 합니다.'
    },
    {
      title: '제 12조 (서비스의 해지)',
      desc: '1. 이용자가 서비스를 해지하고자 할 때에는 서비스별 이용약관에서 정하는 바에 따릅니다.<br/><br/>2. 회사는 제1항의 규정에 의거 해지신청이 접수되면 해지 희망일로부터 일주일 이내에 처리하고 그 날까지의 요금을 완납할 경우에만 해지처리를 합니다.<br/><br/>3. 회사는 이용 등의 납입청구에 대하여 이용자가 이용요금을 체납할 경우 회사는 서비스 이용계약을 직권 해지할 수 있습니다.<br/><br/>4. 이용자가 서비스 이용계약 해지 시 회사는 이용자의 개인정보 및 개인위치정보 수집, 이용, 제공에 대한 확인 자료를 최소 1년간 보유할 수 있으며, 기타 법령규정에 의하여 보전할 필요성이 있는 경우에도 해지자의 개인정보를 보존할 수 있습니다.'
    },
    {
      title: '제 6장 요금 등',
    },
    {
      title: '제 13조 (요금의 종류)',
      desc: '1. 서비스 이용료는 다음과 같습니다.<br/><br/>1) 콩체크 제품 이용요금<br/>콩체크 단말기 : 67,000원(금액(월)) / 190,000원(설치비)<br/><br/>출입문 제어기 : 13,000원(금액(월)) / 150,000원(설치비)',
    },
    {
      title: '',
      desc: '2) 콩체크 서비스 이용요금<br/>1인당 금액(3년 계약) : 1,900 (Basic) / 2,900원 (Standard) / 4,900원 (Enterprise)',
    },
    {
      title: '제 14조 (요금의 적용)',
      desc: '1. 위치정보서비스 금액은 이용자 및 고객사의 특성에 따라 다르게 적용될 수 있습니다.<br/>2. 위치정보 서비스 요금 외 이동통신사 사용요금이 발생할 시 이는 각 이동통신사의 정책에 준합니다.',
    },

    {
      title: '제 15조 (요금등의 납입 기일)',
      desc: '1. 회사는 서비스 이용요금 등의 납입 기일을 사회적 제반 요건을 고려하여 지정합니다.<br/><br/>2. 각 이동통신망을 사용하는 경우 위치정보서비스 요금 외 이동통신사 사용요금은 각 이동통신사의 납입기일 정책에 준합니다.'
    },
    {
      title: '제 16조 (요금 감면, 면제 및 할인)',
      desc: '1. 서비스의 효율성을 제고하고, 서비스지연에 따른 민원을 해소하기 위하여 서비스장애/지연 이용자에게 회사의 이용약관에 의거 요금상의 감면혜택을 부여할 수 있습니다.'
    },
    {
      title: '제 7장 개인위치정보의 수집, 이용, 제공에 대한 동의',
    },
    {
      title: '제 17조 (개인위치정보 수집에 대한 동의)',
      desc: '1. 회사는 원활한 서비스 제공 및 이용자가 사전에 동의한 서비스의 제공을 위하여 개인위치정보주체의 동의하에 개인위치정보를 수집합니다.<br/>2. 회사는 개인위치정보를 수집하는 경우 수집목적을 달성하기 위하여 필요한 최소한의 정보를 수집합니다.<br/>3. 타인의 정보통신기기를 복제하거나 정보를 도용하는 등의 방법으로 위치정보사업자 등을 속여 타인의 개인위치정보를 제공받아서는 안 됩니다.<br/>4. 위치정보를 수집할 수 있는 장치가 부착된 물건을 대여하는 자는 위치정보 수집 장치가 부착된 사실을 대여 받는 자에게 고지하여야 합니다.'
    },
    {
      title: '제 18조 (개인위치정보 이용, 제공에 대한 동의)',
      desc: '1. 회사는 이용자의 개인정보 및 위치정보를 “개인위치정보의 수집목적 및 이용목적”에서 고지한 범위 내에서 사용하며 동 범위를 초과하여 이용하거나, 이용자가 사전에 동의한 제3자의 타인 또는 타 기업 및 기관에게 제공하지 않습니다.<br/>2. 이용자가 사전에 동의한 제3자에게 개인위치정보 제공 시 제공 받는자, 취득경로, 이용, 제공 일시 및 이용 제공방법 등을 이용자가 사전에 지정한 단말기의 SMS 또는 e-mail로 즉시 통보합니다.<br/>3. 위치정보 관련 확인자료 열람 또는 고지 요구 및 제3자에게 정보 제공된 이유 또는 내용 등 열람 가능합니다.',
    },
    {
      title: '제 19조 (계약자와 실사용자가 다른 경우)',
      desc: '1. 서비스 이용계약을 체결한 명의자와 위치정보수집단말 장치의 실사용자가 다른 경우에는 위치정보를 수집할 수 있는 물건을 사용하는 실사용자를 명시하여야 하며, 실사용자의 동의를 얻어야 합니다.<br/>2. 서비스 이용계약에 명시한 계약자, 실사용자 외 실사용자가 누구인지 알 수 없는 경우에는 계약체결자인 명의자를 개인정보주체로 간주합니다.<br/>3. 법인이나 단체와 계약을 체결하는 경우, 회사는 당해 법인이나 단체에게 실제 사용자인 개인위치정보 주체를 특정하여 지정할 것을 요청할 수 있으며, 당해 법인이나 단체는 개인에게 이 사실을 고지하여 개인의 허락을 득하여야 합니다.',
    },
    {
      title: '제 8장 개인위치정보 및 확인자료의 보유기간 및 이용시간',
    },
    {
      title: '제 20조 (개인위치정보의 보유기간 및 이용기간)',
      desc: '1. 회사는 위치정보의 수집, 이용, 제공사실 확인자료를 위치정보시스템에 자동으로 기록하고 보존합니다.<br/>2. 이용자의 위치정보는 회사의 위치정보시스템에 1년간 기록ᐧ저장되며, 수집, 이용, 제공사실 확인자료 외 1년이 지난 위치데이터는 개인에게 사전통보 없이 영구 삭제됩니다.<br/>3. 개인위치정보의 수집, 이용, 제공사실 확인 자료는 이용자의 요구 또는 적법한 절차에 의거한 관계기간의 자료 제시 요구에 대비하기 위하여 최소 1년간 보유할 수 있으며, 기타 법령규정에 의하여 보존할 필요성이 있는 경우에도 해지자의 개인정보를 보존하고 있습니다.'
    },
    {
      title: '제 9장 긴급구조를 위한 개인위치정보의 제공',
    },
    {
      title: '제 21조 (긴급구조를 위한 개인위치정보의 제공)',
      desc: '1. 재난 또는 재해위험 지역 안에 있는 개인에게, 생명, 신체의 위험을 알리기 위해 긴급구조기관이 위치정보사업자에게 경보발송을 요청하는 경우 회사는 이를 고지할 의무가 있습니다.<br/>2. 긴급구조 기관 소방청, 소방본부 및 소방서 또는 해양경찰청, 해양경찰서 등에서 위치정보요청이 있을 경우 회사는 이를 고지할 의무가 있습니다.'
    },
    {
      title: '제 10장 법정대리인의 권리',
    },
    {
      title: '제 22조 (법정대리인)',
      desc: '1. 회사는 14세 미만의 아동으로부터 개인위치정보를 수집, 이용 또는 제공하고자 하는 경우에는 그 법정대리인의 동의를 받아야 합니다.<br/>2. 법정대리인은 14세 미만 아동의 개인위치정보 수집, 이용, 제공에 대하여 동의권 및 동의 유보권, 개인위치 정보의 수집, 이용, 제공에 대한 동의 철회권 및 일시적 중지 요구권을 행사할 수 있습니다.<br/>3. 8세 이하의 아동, 치매, 정신질환, 중증 정신지체 등으로 사리를 분별할 능력이 없는 자의 친권자, 후견인, 부양의무자 그 밖에 의사무능력자 등을 사실상 보호하는 자가 동의하는 경우에 본인의 동의가 있는 것으로 간주하고 위치정보 수집, 이용 및 제공합니다.'
    },
    {
      title: '제 11장 면책 조항',
    },
    {
      title: '제 23조 (면책 조항)',
      desc: '1. 회사는 서비스를 통해 전달되는 자료의 정확성 또는 내용에 대해 일체의 책임을 지지 않습니다.<br/>2. 회사는 통신사 서버 또는 통신 중개업체의 과실로 인한 서비스 불완전으로 발생한 피해는 책임지지 않습니다.<br/>3. 회사는 회원이 유포한 불법 자료나 저작권과 관련된 자료로 입을 수 있는 피해에 대하여 일체의 책임을 지지 않습니다.<br/>4. 회사는 의무를 다했을 경우에 발생하는 피해에 대해서는 일체의 책임을 지지 않습니다.<br/>5. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 없습니다.<br/>6. 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 그 어떠한 책임도 지지 않습니다.<br/>7. 회사는 회원이 서비스를 이용하여 기대되는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여는 그 어떠한 책임도 지지 않습니다.<br/>8. 회사는 회원 상호간 또는 회원과 제3자간에 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해에 대해서는 일체의 책임을 지지 않습니다.<br/>9. 회원이 본 약관의 규정을 위반하여 발생되는 손해에 대해서 해당 회원은 회사에 발생하는 모든 손해를 배상하여야 하며, 동 손해와 관련된 분쟁으로부터 회사를 면책시켜야 합니다.'
    },
    {
      title: '제 12장 손해배상',
    },
    {
      title: '제 24조 (손해배상의 범위)',
      desc: '1. 회사는 회사의 귀책사유로 이용자가 서비스를 이용하지 못하는 경우에는 이용자가 그 사실을 회사에 통보하여 확인한 때(그 전에 회사가 그 사실을 알았거나 알 수 있게 된 때)로부터 계속 24시간 이상의 서비스 제공 중지시간에 대하여 최근 3개월(3개월 미만인 경우는 해당기간 적용)의 1일 평균요금에 서비스제공 중지시간을 24로 나눈 수를 곱하여 산출한 금액의 3배를 배상합니다. 이 경우 단수가 1시간 미만인 경우에는 1시간으로 합니다.<br/>2. 회사는 그 손해가 제15조 제1항의 사유로 발생하였거나 이용자의 고의 또는 과실로 인하여 발생한 때에는 손해를 배상하지 아니합니다.<br/>3. 회사는 이용자가 망사업자의 통신환경에 따라 발생할 수 있는 오차는 위치정보를 이용함으로써 이용자 및 제3자가 입은 손해에 대하여는 배상하지 아니합니다.<br/>4. 이용자는 이용자의 의무 등 이 약관의 제규정을 위반함으로써 회사 및 망사업자가 입은 일체의 손해에 대하여 이용계약이 해지된 이후에도 배상할 책임이 있습니다.<br/><br/>제 25조 (손해배상의 청구)<br/>1. 제24조 제1항에 의한 손해배상의 청구는 회사에 청구사유, 청구금액 및 산출근거를 기재하여 서면으로 하여야 합니다.'
    },
    {
      title: '제 13장 분쟁조정 사항',
    },
    {
      title: '제 27조 (분쟁의 조정 등에 관한 사항)',
      desc: '1. 위치정보와 관련하여 분쟁이 있을 경우 정보통신망이용촉진 및 정보보호 등에 관한 법률 제33조의 규정에 의한 개인정보 분쟁 조정위원회에 분쟁조정을 신청할 수 있으며, 관할 법원기관에서의 진행을 원칙으로 합니다.<br/>2. 회사와 이용자 간에 제기된 정보통신 관련법 소송에는 한국 법을 적용합니다.<br/>3. 회사는 회원으로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리 일정을 즉시 통보해 드립니다.'
    },
    {
      title: '제 14장 구비서류',
    },
    {
      title: '제 28조 (구비서류)',
      desc: '구분: 신청인, 구비서류<br/>개인정보 열람, 정정, 철회, 이용정지 등<br/>고객: 고객신분증, 서비스 열람, 정정, 철회, 이용정지 신청서<br/>법인: 법인 인감증명서, 사업자 등록증 사본, 직원의 신분증, 서비스 열람, 정정, 이용정지 신청서'
    },
    {
      title: "[위치정보관리책임자]",
      desc: "담 당 자: 임호진 책임<br/>소 속: 사업본부 / SW 개발팀<br/>전화번호: 1522-1625<br/>팩시밀리: 070-5143-6695<br/>이 메 일: pr@orbro.io"
    },

  ]
}
